var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 51,
    viewBox: "0 0 101 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5521 37.8281L0.88623 49.661H100.038V0.697205L71.0677 30.8916L58.8267 12.9382L38.4252 45.9887L24.5521 37.8281Z",
    fill: "url(#paint0_linear_87_8279)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.88623 49.661L24.5521 37.8281L38.4252 45.9887L58.8267 12.9382L71.0677 30.8916L100.038 0.697205",
    stroke: "#00B894",
    strokeWidth: 0.816063
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_8279",
    x1: 50.4621,
    y1: 0.697205,
    x2: 50.4621,
    y2: 49.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B894",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.ec16abe0d24d990120460e6e083e4f0d.svg";
export { ForwardRef as ReactComponent };